<template>
  <section class="dealer-list-pane">
    <search-address-parts
      @search="emitSearch"
    />
    <div class="dealer-list-pane__shop-list">
      <dealer-item-parts
        v-if="shopList.length > 0"
        v-for="(shop, index) in shopList"
        :key="`shop-${index}`"
        :shop="shop"
      />
      <p
        v-else
        class="dealer-list-pane__no-data"
        v-text="`表示範囲には店舗が見つかりませんでした。`"
      />
    </div>
  </section>
</template>

<script>
import {defineComponent} from 'vue'
import DealerItemParts from './DealerListPane/parts/DealerItemParts.vue'
import SearchAddressParts from './DealerListPane/parts/SearchAddressParts.vue'

export default defineComponent({
  name: 'DealerListPane',
  components: {
    SearchAddressParts,
    DealerItemParts
  },
  props: {
    shopList: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const emitSearch = (value) => {
      /**
       * 検索ボタンが押されたことを通知する
       */
      context.emit('search', value)
    }

    return {
      emitSearch
    }
  },
})

</script>